var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-sm-12" },
      [
        _c(
          "form",
          {
            attrs: {
              autocomplete: "off",
              method: "post",
              "data-vv-scope": "form",
            },
            on: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return (() => {}).apply(null, arguments)
              },
              submit: function ($event) {
                $event.preventDefault()
                return _vm.onBeforeSaveItem.apply(null, arguments)
              },
            },
          },
          [
            _c("div", { staticClass: "row mb-3" }, [
              _c("div", { staticClass: "col-sm-auto" }, [
                _c("h1", { staticClass: "content-title" }, [
                  _vm._v(_vm._s(_vm.titleItem)),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-9" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c(
                      "MaterialInput",
                      {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|min:3",
                            expression: "'required|min:3'",
                          },
                        ],
                        staticClass: "city-form-group city-bg",
                        attrs: {
                          readonly: _vm.readonlyFormItem,
                          disabled: _vm.readonlyFormItem,
                          type: "text",
                          id: "input-name",
                          name: "name",
                          inputClasses: [
                            { "is-invalid": _vm.fnHasError("name") },
                          ],
                          error: _vm.fnFirstError("name"),
                        },
                        model: {
                          value: _vm.form.name,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form,
                              "name",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.name",
                        },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t(`${_vm.pageID}.model.name`)) +
                            "\n                        "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-3" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c(
                      "MaterialSelect",
                      {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'",
                          },
                        ],
                        staticClass: "city-form-group city-bg",
                        attrs: {
                          disabled: _vm.readonlyFormItem,
                          id: "input-status",
                          name: "status",
                          label: "name",
                          filterable: true,
                          options: _vm.lists.onoff,
                          reduce: (option) => option.code,
                          inputClasses: [
                            { "is-invalid": _vm.fnHasError("status") },
                          ],
                          error: _vm.fnFirstError("status"),
                        },
                        model: {
                          value: _vm.form.status,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form,
                              "status",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.status",
                        },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t(`${_vm.pageID}.model.status`)) +
                            "\n                        "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-5" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c(
                      "MaterialSelect",
                      {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'",
                          },
                        ],
                        staticClass: "city-form-group city-bg",
                        attrs: {
                          disabled: _vm.readonlyFormItem,
                          id: "input-behavior",
                          name: "behavior",
                          label: "name",
                          filterable: true,
                          options: _vm.lists.behaviors,
                          reduce: (option) => option.code,
                          inputClasses: [
                            { "is-invalid": _vm.fnHasError("behavior") },
                          ],
                          error: _vm.fnFirstError("behavior"),
                        },
                        model: {
                          value: _vm.form.behavior,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form,
                              "behavior",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.behavior",
                        },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t(`${_vm.pageID}.model.behavior`)) +
                            "\n                        "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-4 col-xl-5" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c(
                      "MaterialInput",
                      {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "",
                            expression: "''",
                          },
                        ],
                        staticClass: "city-form-group city-bg",
                        attrs: {
                          readonly: _vm.readonlyFormItem,
                          disabled: _vm.readonlyFormItem,
                          id: "input-apikey",
                          name: "apikey",
                          inputClasses: [
                            { "is-invalid": _vm.fnHasError("apikey") },
                          ],
                          error: _vm.fnFirstError("apikey"),
                        },
                        model: {
                          value: _vm.form.apikey,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form,
                              "apikey",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.apikey",
                        },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t(`${_vm.pageID}.model.apikey`)) +
                            "\n                        "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-3 col-xl-2" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c(
                      "MaterialSelect",
                      {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'",
                          },
                        ],
                        staticClass: "city-form-group city-bg",
                        attrs: {
                          disabled: _vm.readonlyFormItem,
                          id: "input-visible",
                          name: "visible",
                          label: "name",
                          filterable: true,
                          options: _vm.lists.onoff,
                          reduce: (option) => option.bool,
                          inputClasses: [
                            { "is-invalid": _vm.fnHasError("visible") },
                          ],
                          error: _vm.fnFirstError("visible"),
                        },
                        model: {
                          value: _vm.form.visible,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form,
                              "visible",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.visible",
                        },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t(`${_vm.pageID}.model.visible`)) +
                            "\n                        "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-3" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c(
                      "MaterialInput",
                      {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "integer|min_value:0",
                            expression: "'integer|min_value:0'",
                          },
                        ],
                        staticClass: "city-form-group city-bg",
                        attrs: {
                          readonly: _vm.readonlyFormItem,
                          disabled: _vm.readonlyFormItem,
                          type: "number",
                          id: "input-minzoom",
                          name: "minzoom",
                          inputClasses: [
                            { "is-invalid": _vm.fnHasError("minzoom") },
                          ],
                          error: _vm.fnFirstError("minzoom"),
                        },
                        model: {
                          value: _vm.form.minzoom,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form,
                              "minzoom",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.minzoom",
                        },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t(`${_vm.pageID}.model.minzoom`)) +
                            "\n                        "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-3" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c(
                      "MaterialInput",
                      {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "integer|min_value:0",
                            expression: "'integer|min_value:0'",
                          },
                        ],
                        staticClass: "city-form-group city-bg",
                        attrs: {
                          readonly: _vm.readonlyFormItem,
                          disabled: _vm.readonlyFormItem,
                          type: "number",
                          id: "input-maxzoom",
                          name: "maxzoom",
                          inputClasses: [
                            { "is-invalid": _vm.fnHasError("maxzoom") },
                          ],
                          error: _vm.fnFirstError("maxzoom"),
                        },
                        model: {
                          value: _vm.form.maxzoom,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form,
                              "maxzoom",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.maxzoom",
                        },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t(`${_vm.pageID}.model.maxzoom`)) +
                            "\n                        "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-3" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c(
                      "MaterialInput",
                      {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: {
                              required: true,
                              regex: /^(0(\.\d{1})?|1(\.0+)?)$/,
                            },
                            expression:
                              "{required: true, regex:/^(0(\\.\\d{1})?|1(\\.0+)?)$/}",
                          },
                        ],
                        staticClass: "city-form-group city-bg",
                        attrs: {
                          readonly: _vm.readonlyFormItem,
                          disabled: _vm.readonlyFormItem,
                          type: "number",
                          step: 0.1,
                          max: 1,
                          min: 0,
                          id: "input-opacity",
                          name: "opacity",
                          inputClasses: [
                            { "is-invalid": _vm.fnHasError("opacity") },
                          ],
                          error: _vm.fnFirstError("opacity"),
                        },
                        model: {
                          value: _vm.form.opacity,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form,
                              "opacity",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.opacity",
                        },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t(`${_vm.pageID}.model.opacity`)) +
                            "\n                        "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-3" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c(
                      "MaterialInput",
                      {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|integer|min_value:1",
                            expression: "'required|integer|min_value:1'",
                          },
                        ],
                        staticClass: "city-form-group city-bg",
                        attrs: {
                          readonly: _vm.readonlyFormItem,
                          disabled: _vm.readonlyFormItem,
                          type: "number",
                          id: "input-order",
                          name: "order",
                          inputClasses: [
                            { "is-invalid": _vm.fnHasError("order") },
                          ],
                          error: _vm.fnFirstError("order"),
                        },
                        model: {
                          value: _vm.form.order,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form,
                              "order",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.order",
                        },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t(`${_vm.pageID}.model.order`)) +
                            "\n                        "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12 col-sm-9" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", { staticClass: "city-label" }, [
                      _vm._v(_vm._s(_vm.$t(`${_vm.pageID}.model.attribution`))),
                    ]),
                    _vm._v(" "),
                    _vm.readonlyFormItem
                      ? [
                          _c("div", {
                            domProps: {
                              innerHTML: _vm._s(_vm.form.attribution),
                            },
                          }),
                        ]
                      : [
                          _c(
                            "div",
                            {
                              staticClass: "city-form-group",
                              class: {
                                "is-invalid": _vm.fnHasError("attribution"),
                              },
                            },
                            [
                              _c("ckeditor", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "",
                                    expression: "''",
                                  },
                                ],
                                attrs: {
                                  name: "attribution",
                                  disabled: _vm.readonlyFormItem,
                                  editor: _vm.cKEditor.editor,
                                  config: _vm.cKEditor.editorConfig,
                                },
                                model: {
                                  value: _vm.form.attribution,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "attribution", $$v)
                                  },
                                  expression: "form.attribution",
                                },
                              }),
                              _vm._v(" "),
                              _vm.fnFirstError("attribution")
                                ? _c(
                                    "small",
                                    { staticClass: "d-block invalid-feedback" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.fnFirstError("attribution"))
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("HelpSpan", {
                                attrs: {
                                  helpText: `${_vm.pageID}.help.attribution`,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                  ],
                  2
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-12 col-sm-3" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex flex-column h-100 pb-3 image-container",
                  },
                  [
                    _c("label", { staticClass: "city-label" }, [
                      _vm._v(_vm._s(_vm.$t(`${_vm.pageID}.model.img`))),
                    ]),
                    _vm._v(" "),
                    _c("UploadSingleImage", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: { required: _vm.isBase },
                          expression: "{required: isBase}",
                        },
                      ],
                      attrs: {
                        disabled: _vm.readonlyFormItem,
                        imageClass: "background-contain",
                        name: "img",
                      },
                      model: {
                        value: _vm.form.img,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "img", $$v)
                        },
                        expression: "form.img",
                      },
                    }),
                    _vm._v(" "),
                    _vm.fnFirstError("img")
                      ? _c(
                          "small",
                          { staticClass: "d-block invalid-feedback" },
                          [_vm._v(_vm._s(_vm.fnFirstError("img")))]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c(
                    "MaterialInput",
                    {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'",
                        },
                      ],
                      staticClass: "city-form-group city-bg",
                      attrs: {
                        readonly: true,
                        disabled: true,
                        id: "input-layer",
                        name: "layer",
                        inputClasses: [
                          { "is-invalid": _vm.fnHasError("layer") },
                        ],
                        error: _vm.fnFirstError("layer"),
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "grpAppend",
                          fn: function () {
                            return [
                              !_vm.readonlyFormItem
                                ? _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-secondary-main btn-sm min-w-auto",
                                      attrs: {
                                        disabled: _vm.readonlyFormItem,
                                        type: "button",
                                        title: _vm.$t(
                                          `${_vm.pageID}.basemap.buttons.gallery.title`
                                        ),
                                        "data-toggle": "tooltip-city",
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.onShowBasemapGallery.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", { staticClass: "fas fa-images" }),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              `${_vm.pageID}.basemap.buttons.gallery.name`
                                            )
                                          ) +
                                          "\n                            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.readonlyFormItem
                                ? _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-secondary-main btn-sm min-w-auto",
                                      attrs: {
                                        disabled: _vm.readonlyFormItem,
                                        type: "button",
                                        title: _vm.$t(
                                          `${_vm.pageID}.basemap.buttons.ogc.title`
                                        ),
                                        "data-toggle": "tooltip-city",
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.onShowBasemapOgc.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fas fa-earth-americas",
                                      }),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              `${_vm.pageID}.basemap.buttons.ogc.name`
                                            )
                                          ) +
                                          "\n                            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.readonlyFormItem
                                ? _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-delete btn-sm min-w-auto",
                                      attrs: {
                                        disabled: _vm.readonlyFormItem,
                                        type: "button",
                                        title: _vm.$t(
                                          `${_vm.pageID}.basemap.buttons.clear.title`
                                        ),
                                        "data-toggle": "tooltip-city",
                                        "data-placement": "left",
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.setBasemap()
                                        },
                                      },
                                    },
                                    [_c("i", { staticClass: "fas fa-xmark" })]
                                  )
                                : _vm._e(),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                      model: {
                        value: _vm.layerName,
                        callback: function ($$v) {
                          _vm.layerName = $$v
                        },
                        expression: "layerName",
                      },
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t(`${_vm.pageID}.model.layer`)) +
                          "\n\n                        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("buttons-footer", {
              attrs: {
                enableButtons: !_vm.readonlyFormItem,
                cancelTitle: _vm.cancelTitle,
                submitTitle: _vm.submitTitle,
                isDisabled: _vm.isDisabled,
              },
              on: {
                save: _vm.onBeforeSaveItem,
                cancel: function ($event) {
                  return _vm.handleBack(`${_vm.moduleCode}.${_vm.pageID}`)
                },
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("BasemapModal", {
          attrs: {
            panelID: _vm.pageID,
            basemapType: _vm.basemapType,
            basemapUrl: _vm.resourcesUrl,
            basemapItems: _vm.galleryItems,
            readonlyFormItem: _vm.readonlyFormItem,
            keyChilds: "map_services",
            keyGroup: "map_service_group_id",
            show: _vm.showBasemapModal,
          },
          on: { select: _vm.onSelectBasemap, close: _vm.onCloseBasemapModal },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }